import PropTypes from "prop-types";
import { StopOutlined } from "@ant-design/icons";
import { Alert, Form } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InsuranceCustomerFormFields from "../../insurance/components/shared/InsuranceCustomerFormFields";
import { mapInsuranceCustomerFormValues } from "../../insurance/lib/insuranceSaleApi";
import useUsStatesWithCoverage from "../../insurance/hooks/useUsStatesWithCoverage";
import customizeRequiredMark from "../../../components/custom_antd/CustomizeRequiredMark";

const CheckInRenterProfileSection = ({ form, provider, customer, missingDetails, verificationStatus }) => {
    const { t: tRes } = useTranslation("reservations");
    const { t: tCheckIn } = useTranslation("checkIn");
    const { t: tSell } = useTranslation("sellInsurance");
    const { states, loading: statesLoading } = useUsStatesWithCoverage();

    useEffect(() => {
        if (customer) {
            form.setFieldsValue(mapInsuranceCustomerFormValues(customer, states));
        }
    }, [customer, form, states]);

    const missingFields = Array.isArray(missingDetails) ? missingDetails.filter(Boolean) : [];
    const descriptionParts = [tRes("startReservationProfileWarningDescription")];

    if (missingFields.length > 0) {
        descriptionParts.push(tRes("startReservationProfileWarningMissing", { fields: missingFields.join(", ") }));
    }

    if (verificationStatus === "no_applicant_id" || verificationStatus === "unverified") {
        descriptionParts.push(tRes("startReservationProfileWarningVerification"));
    }

    descriptionParts.push(tCheckIn("checkInRenterProfileRequiredHint"));

    return (
        <section className="mt-8 border-t border-[#EEF0F6] pt-8">
            <Alert
                type="error"
                showIcon
                icon={<StopOutlined />}
                className="mb-6"
                message={tRes("startReservationProfileWarningTitle")}
                description={descriptionParts.join(" ")}
            />
            <Form form={form} layout="vertical" requiredMark={customizeRequiredMark}>
                <InsuranceCustomerFormFields
                    t={tSell}
                    provider={provider}
                    states={states}
                    statesLoading={statesLoading}
                />
            </Form>
        </section>
    );
};

CheckInRenterProfileSection.propTypes = {
    form: PropTypes.object.isRequired,
    provider: PropTypes.string,
    customer: PropTypes.object,
    missingDetails: PropTypes.arrayOf(PropTypes.string),
    verificationStatus: PropTypes.string,
};

CheckInRenterProfileSection.defaultProps = {
    provider: undefined,
    customer: null,
    missingDetails: [],
    verificationStatus: undefined,
};

export default CheckInRenterProfileSection;
